export const label = /^[a-zA-Z0-9 _-]*$/;
export const keywords = /^[a-zA-Z0-9 ]*$/;
